var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ecircular-template" },
    [
      _c("div", { staticClass: "row ecircular-template__field" }, [
        _c("div", { staticClass: "column small-12" }, [
          _c("div", { staticClass: "row ecircular-template__label " }, [
            _c(
              "label",
              { staticClass: "font-bold column small-10 align-self-bottom" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "settings.department.eCircularTemplate.defaultHeader"
                      )
                    ) +
                    "\n          "
                ),
                _c("span", { staticClass: "font-normal tip__text" }, [
                  _vm._v("(" + _vm._s(_vm.headerPlaceholder) + ")"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column small-2" }, [
              _c("div", { staticClass: "row align-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: { click: _vm.openPreview },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("action.preview")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column small-12" },
          [
            _c("TinymceEditor", {
              key: _vm.editorKey,
              attrs: {
                disabled: !_vm.allowEdit,
                height: _vm.editorHeight,
                additionalToolbar: _vm.additionalToolbar,
              },
              model: {
                value: _vm.headerTemplate,
                callback: function ($$v) {
                  _vm.headerTemplate = $$v
                },
                expression: "headerTemplate",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row ecircular-template__field" }, [
        _c(
          "label",
          {
            staticClass: "ecircular-template__label font-bold column small-12",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("settings.department.eCircularTemplate.defaultFooter")
                ) +
                "\n      "
            ),
            _c("span", { staticClass: "font-normal tip__text" }, [
              _vm._v("(" + _vm._s(_vm.footerPlaceholder) + ")"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column small-12" },
          [
            _c("TinymceEditor", {
              key: _vm.editorKey,
              attrs: {
                disabled: !_vm.allowEdit,
                height: _vm.editorHeight,
                additionalToolbar: _vm.additionalToolbar,
              },
              model: {
                value: _vm.footerTemplate,
                callback: function ($$v) {
                  _vm.footerTemplate = $$v
                },
                expression: "footerTemplate",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row ecircular-template__field" }, [
        _c(
          "label",
          { staticClass: "ecircular-template__label column small-12" },
          [
            _c("span", { staticClass: "font-bold" }, [
              _vm._v(
                _vm._s(_vm.$t("settings.department.eCircularTemplate.logo"))
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-normal" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("settings.department.eCircularTemplate.logoTips_0")
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-normal tip__text" }, [
              _vm._v(
                "(" +
                  _vm._s(
                    _vm.$t("settings.department.eCircularTemplate.logoTips_1")
                  ) +
                  ")"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column small-12" },
          [
            _vm.allowEdit
              ? _c("HkldDropzone", {
                  attrs: {
                    sourceId: _vm.departmentId,
                    metaData: _vm.callCenterMetadata,
                    maxNumberOfFiles: 1,
                    uploadDocTypes: "image/png,image/jpeg",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("EditAttachments", {
              ref: "logoEditAttach",
              attrs: {
                sourceId: _vm.departmentId,
                canEdit: _vm.allowEdit,
                canDelete: _vm.allowEdit,
                canDownloadAll: false,
                filesFilterFn: _vm.filterECircularCallCenter,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "previewModal", attrs: { modalType: "large-modal" } },
        [_c("ECircularPreview", { attrs: { dataSrc: _vm.previewData } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }